.report-container {
  padding: 24px 0;
  width: 100%;
  max-width: 1200px;
  min-width: 650px;
  margin: 0 auto;
  box-sizing: border-box;
  border-radius: 8px;
}

@media (max-width: 600px) {
  .report-container {
    padding: 10px 15px;
    min-width: unset;
    width: 100%;
  }
}

.report-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e0e0e0;
}

.report-title-section {
  flex: 1;
}

.report-title {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
}

.report-subtitle {
  font-size: 16px;
  color: var(--body-text);
  margin: 0;
}

.report-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.report-content {
  margin-top: 30px;
}

.sidebar {
  display: flex;
  flex-direction: column;
  width: 330px;
  gap: 1rem;
}

.report-container-scroll {
  height: 59vh;
  overflow: scroll;
  padding: 10px;
}

.p-unset {
  padding: 0.6em 1.2em !important;
}

.snackbarButton {
  color: white !important;
  text-transform: none !important;
  font-weight: normal !important;
  display: flex;
  align-items: center;
}
